import React, { useEffect, useState } from 'react';
import { WORKLIST_MAPPING_ANY_MATCH, WorklistScriptMapping } from '../../reducers/worklistReducer';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { getNodes, getScriptsOfType, getWorklistNodes } from '../../reducers/selectors';
import { RootState } from '../../reducers';
import * as nodesActions from '../../actions/nodesActions';
import * as worklistActions from '../../actions/worklistActions';
import * as scriptActions from '../../actions/scriptActions';
import { useAppDispatch } from '../../hooks';

interface IWorklistScriptsMappingForm {
  mapping: WorklistScriptMapping | null;
  onClose: () => void;
  onSave: (_: WorklistScriptMapping) => void;
  saveButtonLabel: string;
}

export default function WorklistScriptsMappingForm({
  mapping,
  onClose,
  onSave,
  saveButtonLabel,
}: IWorklistScriptsMappingForm) {
  const dispatch = useAppDispatch();
  const nodes = useSelector(getNodes);
  const worklistNodes = useSelector(getWorklistNodes);
  const scripts = useSelector((state: RootState) => getScriptsOfType(state, 'WORKLIST'));

  const [callingAet, setCallingAet] = useState<string>(mapping ? mapping.callingAet : '-1');
  const [worklistNode, setWorklistNode] = useState<string>(mapping ? mapping.worklistNode : '-1');
  const [scriptName, setScriptName] = useState<string>(mapping ? mapping.scriptName : '-1');
  const [enabled, setEnabled] = useState<boolean>(mapping ? mapping.enabled : true);

  useEffect(() => {
    dispatch(nodesActions.getNodes());
    dispatch(worklistActions.getWorklistNodes());
    dispatch(scriptActions.getAllScripts());
  }, []);

  const save = () => {
    let valid = true;
    valid = valid && callingAet !== '-1' && callingAet.trim().length > 0;
    valid = valid && worklistNode !== '-1' && worklistNode.trim().length > 0;
    valid = valid && scriptName !== '-1' && scriptName.trim().length > 0;

    if (valid) {
      const pk = mapping ? mapping.pk : -1;
      const orderIndex = mapping ? mapping.orderIndex : -1;
      onSave({ callingAet, worklistNode, scriptName, enabled, pk, orderIndex });
    }
  };

  return (
    <Form>
      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Calling AET
        </Form.Label>
        <Col sm={8}>
          <Form.Control
            size="sm"
            as="select"
            value={callingAet}
            onChange={e => setCallingAet(e.target.value)}
            defaultValue="-1"
            isInvalid={!callingAet || callingAet === '-1'}
          >
            <option value="-1" disabled>
              Select calling AET...
            </option>
            <option value={WORKLIST_MAPPING_ANY_MATCH}>All calling AETs</option>
            {nodes
              .filter(node => node.enabled)
              .map(node => (
                <option key={node.pk} value={node.aeTitle}>
                  {node.aeTitle}
                </option>
              ))}
          </Form.Control>
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Worklist node
        </Form.Label>
        <Col sm={8}>
          <Form.Control
            size="sm"
            as="select"
            value={worklistNode}
            onChange={e => setWorklistNode(e.target.value)}
            defaultValue="-1"
            isInvalid={!worklistNode || worklistNode === '-1'}
          >
            <option value="-1" disabled>
              Select worklist node...
            </option>
            <option value={WORKLIST_MAPPING_ANY_MATCH}>All worklist nodes</option>
            {worklistNodes
              .filter(node => node.enabled)
              .map(node => (
                <option key={node.pk} value={node.displayName}>
                  {node.displayName}
                </option>
              ))}
          </Form.Control>
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Script
        </Form.Label>
        <Col sm={8}>
          <Form.Control
            size="sm"
            as="select"
            value={scriptName}
            onChange={e => setScriptName(e.target.value)}
            defaultValue="-1"
            isInvalid={!scriptName || scriptName === '-1'}
          >
            <option value="-1" disabled>
              Select script...
            </option>
            {scripts.map(script => (
              <option key={script.name} value={script.name}>
                {script.name}
              </option>
            ))}
          </Form.Control>
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column sm={4} md={{ offset: 1 }} className="font-weight-bold">
          Enabled
        </Form.Label>
        <Col sm={8} className="worklistNodeForm">
          <Form.Check
            custom
            id="enable-worklist-mapping"
            type="checkbox"
            checked={enabled}
            onChange={() => setEnabled(!enabled)}
          />
        </Col>
      </Form.Group>

      <div style={{ textAlign: 'right', marginTop: '3em' }}>
        <Button onClick={onClose} variant="outline-secondary" style={{ marginRight: '5px' }}>
          Cancel
        </Button>
        <Button style={{ width: '8em' }} variant="primary" onClick={save}>
          {saveButtonLabel}
        </Button>
      </div>
    </Form>
  );
}
